import { Outlet } from 'react-router-dom';
import type { NavigationItemType } from '@/types/nav.types';

export function SinglePageAppLayout({
  navigationItems: _navigationItems,
}: {
  navigationItems: NavigationItemType[];
}) {
  return <Outlet />;
}
